import {ApiPlant} from '../../models/Model';
import {IPlantCategory} from '../../models/Products';
import transformApiPlantToPlant from './transformApiPlantToPlant';
import {convertSnakeCaseToCapital} from '../util/convertSnakeCaseToCapital';

const transformApiPlantsToIPlantCategoryArray = (apiPlants: ApiPlant[], plantBaseUrl: string): IPlantCategory[] => {
    const plantCategoriesRecord: Record<string, IPlantCategory> = {};
    apiPlants.forEach((apiPlant) => {
        const plant = transformApiPlantToPlant(apiPlant, plantBaseUrl);
        if (plant.archived || plant.outOfStock) {
            return;
        }
        if (apiPlant.plant.category in plantCategoriesRecord) {
            plantCategoriesRecord[apiPlant.plant.category].plants.push(plant);
        } else {
            plantCategoriesRecord[apiPlant.plant.category] = {
                id: apiPlant.plant.category,
                name: convertSnakeCaseToCapital(apiPlant.plant.category),
                plants: [plant]
            }
        }
    });
    return Object.values(plantCategoriesRecord);
};

export default transformApiPlantsToIPlantCategoryArray;
